module.exports = __webpack_public_path__ + "img/symbol_7.a2ef0ed7.png";